import { jsx } from "react/jsx-runtime";
import Markdown from "markdown-to-jsx";
import { INVALID_PROPS_ERROR, COMPONENT_NAME } from "./constants.js";
import { MarkdownContainer } from "./styles.js";
import { getDataTestId } from "../../Util/index.js";
const MarkdownRenderer = ({
  markdown,
  overrides = {},
  uniqueId,
  linkColor,
  styles = {}
}) => {
  if (!markdown) {
    console.error(INVALID_PROPS_ERROR);
    return null;
  }
  return /* @__PURE__ */ jsx(
    MarkdownContainer,
    {
      "data-testid": getDataTestId(COMPONENT_NAME, uniqueId),
      linkColor,
      styles,
      children: /* @__PURE__ */ jsx(Markdown, { options: { overrides }, children: markdown })
    }
  );
};
MarkdownRenderer.displayName = COMPONENT_NAME;
export {
  MarkdownRenderer
};
